(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-benefits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest(".es-benefit-accordions details");
  if (item) item.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest(".es-faq-list details");
  if (item) item.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-written-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('emerald-written-reviews')) {
  customElements.define('emerald-written-reviews', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.rows = Array.from(this.querySelectorAll('[data-review-index]'));
      this.controls = this.querySelector('.es-written-controls');
      this.button = this.querySelector('.es-written-more');
      this.status = this.querySelector('.es-written-status');
      this.pageSize = Number(this.dataset.pageSize) || 3;
      this.visibleCount = this.dataset.editor === 'true' ? this.rows.length : Math.min(this.pageSize, this.rows.length);
      this.update();
      this.button?.addEventListener('click', () => {
        const firstNewRow = this.rows[this.visibleCount];
        this.visibleCount = Math.min(this.visibleCount + this.pageSize, this.rows.length);
        this.update(true);
        firstNewRow?.focus();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('.es-written-batch');
        if (!block || !this.contains(block)) return;
        const row = block.querySelector('[data-review-index]');
        const index = this.rows.indexOf(row);
        if (index < 0) return;
        this.visibleCount = Math.max(this.visibleCount, Math.min(Math.ceil((index + 1) / this.pageSize) * this.pageSize, this.rows.length));
        this.update();
        row.scrollIntoView({ block: 'nearest' });
      }, options);
    }
    disconnectedCallback() { this.abortController?.abort(); }
    update(announce = false) {
      this.rows.forEach((row, index) => { row.hidden = index >= this.visibleCount; });
      if (this.controls) this.controls.hidden = this.visibleCount >= this.rows.length;
      if (announce && this.status) this.status.textContent = (this.dataset.progress || '').replace('[shown]', this.visibleCount).replace('[total]', this.rows.length);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
